module.exports = __webpack_public_path__ + "static/media/8.eaa1804a.jpg";